import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Illustrator = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">What will I learn in this course?</h1>
          <ul>
            <li>Introducing illustrator cc</li>
            <li>Creating documents containing basic shapes</li>
            <li>Creating documents containing customized paths</li>
            <li>Creating graphics containing customized text</li>
            <li>Customizing objects</li>
            <li>Customizing basic shapes</li>
            <li>Preparing documents for deployment</li>
          </ul>
          <p><b>Session 1: Introducing illustrator cc</b></p>
          <p>Apply Design Principles, Elements, and Graphics Composition, Evaluate Graphics Scalability, Navigate the User Interface, Customize the User Interface</p>
          <p><b>Session 2: Creating documents containing basic shapes</b></p>
          <p>Create Documents,Save Documents,Draw Basic Shapes</p>
          <p><b>Session 3: Creating documents containing customized paths</b></p>
          <p>Draw Paths,Modify Paths</p>
          <p><b>Session 4: Creating graphics containing customized text</b></p>
          <p>Insert Text,Apply Flow Text Along a Path,Insert Bounded and Threaded Text,Apply Text Styles,Insert Typographical Characters</p>
          <p><b>Session 5: Customizing objects</b></p>
          <p>Import, Place, and Link Graphics, Alter the Appearance of Objects</p>
          <p><b>Session 6: Customizing basic shapes</b></p>
          <p>Apply Strokes and Brushes,Fill Shapes,Apply Graphics Styles,Distort Text with Text Envelopes</p>
          <p><b>Session 7: Preparing documents for deployment</b></p>
          <p>Update Text,Wrap Text,Hyphenate Text,Optimize Content for Print,Optimize Content for the Web,Optimize Content for PDF Documents</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Illustrator